import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import store from "@/store";

Vue.prototype.$vendas = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      vendas: [],
      filtro: {
        sequencial: "",
        idregional: "",
        nome_consumidor: "",
        email_consumidor: "",
        localizador: "",
        ped_status: "",
        dthr_ini_ped: "",
        dthr_fim_ped: "",
        forma_pag: "",
        canal_venda: "",
        agente: "",
        ponto_de_venda: "",
      },
      loading_vendas: false,
      loading_button: false,
      loading_select: false,
      filter: {
        nome_consumidor: "",
        email_consumidor: "",
        cod_pedido: "",
        status: "",
        data_inicial: "",
        hora_inicial: "",
        data_final: "",
        hora_final: "",
        regional: "",
        forma_pagamento: "",
        loja: "",
        canal_de_vendas: "",
        agente: "",
        ponto_de_venda: "",
        error: {
          loja: [],
        },
      },
      itens_pedido: [],
      itens_mkt: [],
      lojas_mkt: "",
      idconsumidor: "",
      itens_pedido_totais: [],
      loading_itens_pedido: false,
      canais_de_venda: [],
      formas_de_pagamento: [],
      regionais: [],
      status_pedido: [],
      loading_status: false,
    };
  },
  methods: {
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return true;
      else return false;
    },

    getVendas(filtros) {
      this.loading_vendas = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_VENDAS, JSON.stringify(filtros))
        .then(response => {
          const arrayOfObj = Object.entries(response).map(e => e[1]);

          this.vendas = arrayOfObj;
        })
        .catch(error => {
          throw new Error(error);
        })
        .finally(() => {
          this.loading_vendas = false;
          this.loading_button = false;
          this.loading_select = false;
        });
    },

    getItensPedido(idpedido, sequenciador) {
      this.loading_itens_pedido = true;
      this.$axios
        .get(this.ENDPOINTS.LISTAR_ITENS_PEDIDO + sequenciador + "/" + idpedido)
        .then(response => {
          this.itens_pedido = response.itens;
          this.itens_pedido_totais = [response.totais];
          this.loading_itens_pedido = false;
        })
        .catch(error => {
          this.loading_itens_pedido = false;
          throw new Error(error);
        });
    },

    getItensPedidoMkt(idpedido_marketplace, ano_mes) {
      this.loading_itens_pedido = true;
      this.$axios
        .get(
          this.ENDPOINTS.LISTAR_ITENS_PEDIDO_MKT +
            ano_mes +
            "/" +
            idpedido_marketplace
        )
        .then(response => {
          this.itens_pedido = response.itens;
          this.itens_mkt = response.itens.map(
            ({ sequenciador }) => sequenciador
          );
          this.lojas_mkt = this.itens_mkt.join(";");
          this.itens_pedido_totais = [response.totais];
          this.loading_itens_pedido = false;
        })
        .catch(error => {
          this.loading_itens_pedido = false;
          throw new Error(error);
        });
    },

    getStatusPedido() {
      this.loading_status = true;
      this.$axios
        .get(this.ENDPOINTS.LISTAR_STATUS_PEDIDO + "/array")
        .then(response => {
          this.status_pedido = response;
          this.loading_status = false;
        })
        .catch(error => {
          this.loading_status = false;
          throw new Error(error);
        });
    },

    validateTicket(payload) {
      this.$axios.post(this.ENDPOINTS.VALIDATE_TICKET, payload);
    },

    clearFilterFields(field) {
      switch (field) {
        case "loja":
          this.filter.loja = "";
          break;
      }
    },

    filtroVendas() {
      this.loading_vendas = true;
      this.loading_button = true;
      this.loading_select = true;
      this.filtro = {
        sequencial: store.getters.storeSequencial,
        idregional: "",
        nome_consumidor: "",
        email_consumidor: "",
        localizador: "",
        status: "",
        dthr_ini_ped: "",
        dthr_fim_ped: "",
        forma_pag: "",
        canal_venda: "",
        agente: "",
        ponto_de_venda: "",
      };

      if (this.filter.loja !== "" && this.filter.loja !== null) {
        this.filtro.sequencial = this.filter.loja;
      }

      if (this.filter.regional != "" && this.filter.regional != null) {
        this.filtro.idregional = this.filter.regional;
      }

      if (this.filter.nome_consumidor != "") {
        this.filtro.nome_consumidor = this.filter.nome_consumidor;
      }

      if (this.filter.email_consumidor != "") {
        this.filtro.email_consumidor = this.filter.email_consumidor;
      }

      if (this.filter.cod_pedido != "") {
        this.filtro.localizador = this.filter.cod_pedido;
      }

      if (this.filter.status != "" && this.filter.status != null) {
        this.filtro.ped_status = this.filter.status;
      }

      if (this.filter.data_inicial != "") {
        this.filtro.dthr_ini_ped =
          this.filter.data_inicial +
          (this.filter.hora_inicial
            ? " " + this.filter.hora_inicial
            : " 00:00");
      }

      if (this.filter.data_final != "") {
        this.filtro.dthr_fim_ped =
          this.filter.data_final +
          (this.filter.hora_final ? " " + this.filter.hora_final : " 23:59");
      }

      if (
        this.filter.forma_pagamento != "" &&
        this.filter.forma_pagamento != null
      ) {
        this.filtro.forma_pag = this.filter.forma_pagamento;
      }

      if (
        this.filter.canal_de_vendas != "" &&
        this.filter.canal_de_vendas != null
      ) {
        this.filtro.canal_venda = this.filter.canal_de_vendas;
      }

      if (this.filter.agente != "" && this.filter.agente != null) {
        this.filtro.agente = this.filter.agente;
      }

      if (
        this.filter.ponto_de_venda != "" &&
        this.filter.ponto_de_venda != null
      ) {
        this.filtro.ponto_de_venda = this.filter.ponto_de_venda;
      }

      this.getVendas(this.filtro);
    },

    limpaFiltros() {
      this.filter.nome_consumidor = "";
      this.filter.email_consumidor = "";
      this.filter.cod_pedido = "";
      this.filter.status = "";
      this.filter.data_inicial = "";
      this.filter.data_final = "";
      this.filter.regional = "";
      this.filter.forma_pagamento = "";
      this.filter.loja = "";
      this.filter.canal_de_vendas = "";
      this.filter.agente = "";
      this.filter.ponto_de_venda = "";
      this.vendas = [];
    },
  },
});
